import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const MapListDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_829_59019)">
      <path
        d="M3.07499 0.875H1.49999C0.924988 0.875 0.424988 1.35 0.424988 1.95V3.525C0.424988 4.1 0.899988 4.6 1.49999 4.6H3.07499C3.64999 4.6 4.14999 4.125 4.14999 3.525V1.925C4.12499 1.35 3.64999 0.875 3.07499 0.875ZM2.99999 3.45H1.57499V2H2.99999V3.45Z"
        fill="#EEF7FF"
      />
      <path
        d="M6.42498 3.29999H15C15.3 3.29999 15.575 3.04999 15.575 2.72499C15.575 2.39999 15.325 2.14999 15 2.14999H6.42498C6.12498 2.14999 5.84998 2.39999 5.84998 2.72499C5.84998 3.04999 6.12498 3.29999 6.42498 3.29999Z"
        fill="#EEF7FF"
      />
      <path
        d="M3.07499 6H1.49999C0.924988 6 0.424988 6.475 0.424988 7.075V8.65C0.424988 9.225 0.899988 9.725 1.49999 9.725H3.07499C3.64999 9.725 4.14999 9.25 4.14999 8.65V7.075C4.12499 6.475 3.64999 6 3.07499 6ZM2.99999 8.575H1.57499V7.125H2.99999V8.575Z"
        fill="#EEF7FF"
      />
      <path
        d="M15 7.3H6.42498C6.12498 7.3 5.84998 7.55 5.84998 7.875C5.84998 8.2 6.09998 8.425 6.42498 8.425H15C15.3 8.425 15.575 8.175 15.575 7.875C15.575 7.575 15.3 7.3 15 7.3Z"
        fill="#EEF7FF"
      />
      <path
        d="M3.07499 11.425H1.49999C0.924988 11.425 0.424988 11.9 0.424988 12.5V14.075C0.424988 14.65 0.899988 15.15 1.49999 15.15H3.07499C3.64999 15.15 4.14999 14.675 4.14999 14.075V12.5C4.12499 11.9 3.64999 11.425 3.07499 11.425ZM2.99999 14H1.57499V12.55H2.99999V14Z"
        fill="#EEF7FF"
      />
      <path
        d="M15 12.7H6.42498C6.12498 12.7 5.84998 12.95 5.84998 13.275C5.84998 13.6 6.09998 13.85 6.42498 13.85H15C15.3 13.85 15.575 13.6 15.575 13.275C15.575 12.95 15.3 12.7 15 12.7Z"
        fill="#EEF7FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_829_59019">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MapListDark;
